'use client'
import { ShopifyBundle } from "lib/shopify/types";
import Image from "next/image";
import { useState } from "react";
import { BundleAddToCartItemInfo } from "./bundle-add-to-cart-item-info";

const bundleItemsOrder = [
    'display-hub',
    'hubkeypad',
    'door-window-sensor',
    'motion-sensor',
    'smoke-and-heat-sensor',
    'indoor-camera',
    'outdoor-security-cameras',
]
interface BundleAddToCartItemProps {
    bundleHandle: {
        value: {
            data: {
                title: string,
                cameraList: {handle: string, name: string, image: string, includedInThisPackage: string}[],
                properties: {title: string, content: string}[]
                isBundle: boolean
                bundleItems: {handle: string, content: string}[]
                handle: string
            }
        }
    },
    redirectUrl: string,
    showPackagesButton: boolean,
    layout: 'default' | 'compact'
}

export function BundleAddToCartItem({bundleHandle, redirectUrl, showPackagesButton, layout }: BundleAddToCartItemProps) {
    if(!bundleHandle) return <div>No product details data, please connect to a Builder.io product details data model</div>
    const data = bundleHandle.value.data
    const title = data.title
    const cameraList = data.cameraList
    const properties = data.properties
    const summary = properties.find((property: any) => property.title === 'Summary')?.content
    const description = properties.find((property: any) => property.title === 'Description')?.content
    const bundleItems = data.bundleItems

    const [selectedCamera, setSelectedCamera] = useState<{handle: string, name: string, image: string, includedInThisPackage: string}>(cameraList[0]!)
    const [bundles, setBundles] = useState<ShopifyBundle[]>([])
    const [bundlesLoading, setBundlesLoading] = useState(true)

    const sortBundleItems = (items: { handle: string, content: string }[]) => {
        return [...items].sort((a, b) => {
            if (a.handle === 'home-defense-kit') return 1;
            if (b.handle === 'home-defense-kit') return -1;
            
            const indexA = bundleItemsOrder.indexOf(a.handle);
            const indexB = bundleItemsOrder.indexOf(b.handle);
            return indexA - indexB;
        });
    };    

    const isDefault = layout === 'default'
    
    return (
        <div className="flex flex-col md:flex-row w-full h-full bg-white rounded-2xl border-none">
            <div className="w-full px-8 flex flex-col h-full">
                <div>
                    {isDefault &&
                        <h2 className="text-[28px] mt-8 text-fp-dark-gray font-bold">
                            {title}
                        </h2>
                    }
                    <div className="w-full order-1 md:order-2 rounded-2xl py-8">
                        {selectedCamera?.image && <Image src={selectedCamera?.image} alt={`${title} - camera`} width={800} height={800} className="w-full h-auto rounded-2xl"/>}
                    </div>  
                </div>
                {isDefault &&
                    <BundleAddToCartItemInfo bundleHandle={bundleHandle} showPackagesButton={showPackagesButton} selectedCamera={selectedCamera} setSelectedCamera={setSelectedCamera} />
                }
            </div>
        </div>
    )
}

export const getAvailableCameras = (availableBundles :ShopifyBundle[])=>{
    const allProductBundles = availableBundles.map(bundle => bundle.bundleComponents.nodes.map((node) => {return {componentProduct: node.componentProduct, bundle, quantity: node.quantity}})).flat()
    const availableCameras = allProductBundles.filter(product => product.componentProduct.title.toLowerCase().includes('camera'))
    const camerasDict: { [key: string]: any[] } = {}
    for (const bundle of availableBundles) {
        camerasDict[bundle.handle] = []
    }
    for (const camera of availableCameras) {
        if(camerasDict[camera.bundle.handle]){
            camerasDict[camera.bundle.handle]?.push(camera)
        }else{
            camerasDict[camera.bundle.handle] = [camera]
        }
    }
    for (const bundle of availableBundles) {
        if(!camerasDict[bundle.handle]?.length){
            camerasDict[bundle.handle]?.push({componentProduct: {title: 'No Camera', handle: 'no-camera'}, bundle, quantity: 0})
        }
    }
    return Object.entries(camerasDict).map(([key, value]) => {
        return {
            bundle: value[0].bundle,
            cameras: value.map(camera => {return {item: camera.componentProduct, quantity: camera.quantity} })
        }
    })   
}


const BundleLoading = ()=>{
    const skeleton = 'w-full h-6 animate-pulse rounded bg-neutral-200 dark:bg-neutral-700';

    return (
        <div className="grid grid-cols-1 gap-4 w-full mt-8 pt-4">
            <div className={skeleton} />
            <div className={skeleton} />            
        </div>
    )
}
